module.exports = ".user-profile .user-pic img{width:73px;height:69px}\n"